import { Directive, Input } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';


// Note: This directive was originally: "angular-compare-validator": "^0.2.0",
// but due updating the ArmWebComponent to Angular 16, angular-compare-validator
// was no longer compatible.  So, I copied the source code from the original: 
// https://github.com/GeorgDangl/angular-compare-validator/blob/master/src/compare-validator.directive.ts
// - kevin.low 12/22/2023
@Directive({
    selector: '[compareEqual]',
    providers: [{ provide: NG_VALIDATORS, useExisting: CompareValidatorDirective, multi: true }],
    standalone: true
})
export class CompareValidatorDirective implements Validator {

    private _valueToCompare: any;
    private onNotifyValueChange: () => void;
    // TODO: Skipped for migration because:
    //  Accessor inputs cannot be migrated as they are too complex.
    @Input('compareEqual')
    set valueToCompare(value: any) {
        if (value !== this._valueToCompare) {
            this._valueToCompare = value;
            let handler = this.onNotifyValueChange;
            if (handler) {
                handler();
            }
        }
    }

    registerOnValidatorChange(fn: () => void): void {
        this.onNotifyValueChange = fn;
    }

    validate(control: AbstractControl): { [key: string]: any } {
        if (this._valueToCompare == null && control.value == null) {
            // Not producing an error if both values are null 
            return null;
        }
        return (control.value !== this._valueToCompare)
            ? { 'compareEqual': true }
            : null;
    }
}